import React from "react";

export function Textarea({ rows = 4, label, placeholder, span = 2, requerid = true, change }) {
  const colSpanClass = span === '1' || span === 1 ? 'col-span-1' : 'col-span-2';
  return (
    <div className={colSpanClass}>
      <label className="block mb-1.5 text-xs font-semibold uppercase tracking-wider text-slate-600">
        {label} {requerid && <span className="text-rose-500">*</span>}
      </label>
      <textarea
        rows={rows}
        className="w-full px-4 py-2.5 bg-slate-50 border border-slate-200 rounded-xl text-slate-800 placeholder:text-slate-400 text-sm font-medium transition-all duration-200 focus:bg-white focus:border-primary focus:ring-4 focus:ring-primary/15 focus:outline-none shadow-xs resize-none"
        placeholder={placeholder}
        required={requerid}
        onChange={(event) => change(event.target.value)}
      />
    </div>
  );
}